package com.neurobs.ccabserver.administrator.controller

import com.neurobs.ccab._
import com.neurobs.ccab.MessageType._
import io.circe.generic.auto._
import com.neurobs.ccab.MessageData._

/** Handles the details of sending messages to Test Station
 *
 * @param adapter Object used to actually send messages
 */
class TestStationAdapter (adapter: SendMessageAdapter) {
	def getControllerState: Unit = adapter.send(GetControllerState)

	def getCommState: Unit = adapter.send(GetCommState)

	def getTestPackageData: Unit = adapter.send(GetTestPackageData)

	def setSession(data: SetSessionData): Unit = adapter.send(SetSessionMessage(data = data))

	def getSessionData: Unit = adapter.send(GetSessionData)

	def getPowerStatus: Unit = adapter.send(GetPowerStatus)

	def getState: Unit = adapter.send(GetState)

	def getTestDetail(logIndex: Int): Unit = adapter.send(GetTestDetailMessage(data = GetTestDetailData(logIndex)))

	def setPauseBetween(pauseBetween: Boolean): Unit = adapter.send(if (pauseBetween) SetPauseBetweenTrue else SetPauseBetweenFalse)

	def resumeSequence: Unit = adapter.send(ResumeSequence)

	def pauseSequence: Unit = adapter.send(PauseSequence)

	def rerunTest(run: TestRunDetail, startPosition: Option[String], updateSequencePosition: Boolean): Unit = {
		val data = StartTestData(
			test_index = run.run.test,
			start_value = startPosition,
			sequence_id = run.run.seq_id,
			update_seq_pos = updateSequencePosition
		)
		adapter.send(StartTestMessage(data = data))
	}

	def runTest(item: SequenceElement, startPosition: Option[String], updateSequencePosition: Boolean): Unit = {
		val data = StartTestData(
			test_index = item.index,
			start_value = startPosition,
			sequence_id = Some(item.id),
			update_seq_pos = updateSequencePosition
		)
		adapter.send(StartTestMessage(data = data))
	}

	def quitTest: Unit = adapter.send(QuitTest)

	def setSubjectAV(data: SetSubjectAVData): Unit = adapter.send(SetSubjectAVMessage(data = data))

	def clearHelpRequested: Unit = adapter.send(ClearHelpRequested)

	def shutdownTestStationApp(): Unit = adapter.send(ShutdownControllerMessage(data = ShutdownControllerData(shutdown_app = true, shutdown_system = false)))

	def shutdownTestStationSystem(): Unit = adapter.send(ShutdownControllerMessage(data = ShutdownControllerData(shutdown_app = true, shutdown_system = true)))
}
